import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LAST_REFILLED_QUERY_KEY } from "@coworker/app/src/hooks/Locations/useLocationLastRefilled";
import { getRefillAreaIdFromLocation } from "@fixa/store-locations";
import {
  IN_PROGRESS_TASKS_QUERY_KEY,
  OPEN_TASKS_QUERY_KEY,
  OVERVIEW_TASKS_QUERY_KEY,
} from "../../TasksOverview/constants/queryKeys";

async function createTask(data: object) {
  const path = `/v1/task/create`;
  const url = `${TASKS_SERVICE_URL}${path}`;
  const { result } = await fetchAPI("POST", url, data, "json");
  return result;
}

export function useCreateTaskMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { data: object }) => {
      return await createTask(data.data);
    },
    onSuccess: async (data) => {
      const taskId = data?.task_id;
      queryClient.setQueryData(["task", "id", taskId, data.task_type], data);

      queryClient.invalidateQueries({
        queryKey: [
          OVERVIEW_TASKS_QUERY_KEY,
          data.assigned_user_id
            ? IN_PROGRESS_TASKS_QUERY_KEY
            : OPEN_TASKS_QUERY_KEY,
        ],
      });

      if (data.task_type === "ADDON" && data.state === "COMPLETED") {
        queryClient.removeQueries({
          queryKey: [
            LAST_REFILLED_QUERY_KEY,
            data.product_article_id,
            data.location_grid_code || data.location_custom,
          ],
        });
        queryClient.removeQueries({
          queryKey: [
            "articlesByRefillArea",
            `${getRefillAreaIdFromLocation(
              data.location_grid_code || data.location_custom
            )}`,
          ],
        });
      }
    },
    onError: (error) => {
      console.log("Error while creating task", error);
    },
  });
}
